/***
*
*   SPACES NAV
*   Acount sub nav that renders different options based
*   on user permissions. Shows billing & user admin to only account owners
*
**********/

import React from 'react';
import { SubNav } from 'components/lib';

export function CollectionNav(props){

  return(
    <SubNav items={[

      { link: '/community/' + props.collection_id, label: 'Main'},
      { link: '/community/game/' + props.collection_id, label: 'Games'},

    ]}/>
  );
}